import { AType, summon } from "@silversea-ssc/functional-support"
import * as PositiveInt from "@ssc-booking/functional-support/src/positive-int"
import * as NonNegativeInt from "@ssc-booking/functional-support/src/non-negative-int"

export const Occupancy = summon((F) =>
    F.interface(
        {
            adults: PositiveInt.PositiveInt(F),
            kids: NonNegativeInt.NonNegativeInt(F),
        },
        "Occupancy",
    ),
)
export type Occupancy = AType<typeof Occupancy>

export const totalGuests = (occupancy: Occupancy): PositiveInt.PositiveInt =>
    PositiveInt.buildUnsafe(occupancy.adults + occupancy.kids)
export const otherGuests = (occupancy: Occupancy): NonNegativeInt.NonNegativeInt =>
    NonNegativeInt.buildUnsafe(totalGuests(occupancy) - 1)
export const of = (adults: number, kids = 0): Occupancy =>
    Occupancy.build({ adults: PositiveInt.buildUnsafe(adults), kids: NonNegativeInt.buildUnsafe(kids) })
export const build = Occupancy.build

export const strictType = Occupancy.strictType
